module.exports = __webpack_public_path__ + "img/headimg-1793698374569.png";